/** @format */

export const BUTTON_LABELS = {
	storePickup: 'Free Store Pickup',
	shipToStore: 'Free Ship To Store'
} as const;

export const BUTTON_TEXTS = {
	pickupAtStore: (storeName: string) => `Pickup at ${storeName}` as const,
	inStockAtStore: (storeName: string) => `In stock at ${storeName}` as const,
	temporarilyClosed: (storeName: string) => `${storeName} temporarily closed` as const,
	noSkuResolved: 'Select product options',
	shipToStore: 'Pickup in 5-10 days',
	purchaseInStore: 'Purchase in-store',
	notAvailable: 'Not available',
	storeClosed: 'Temporarily closed',
	available: 'Available',
	preOrder: 'Pre-Order',
	orderBy2: 'Order by 2pm, get it today',
	notAvailableTo: 'Not available to',
	addToSet: 'Add product to set'
} as const;

export const LABEL_TEXTS = {
	pickupAtStore: 'Pick up at',
	inStockAtStore: 'In Stock at',
	notAvailableAt: 'Not available at',
	shipTo: 'Ship to',
	notAvailableToShip: 'Not available to',
	sdd: 'Same Day Delivery to'
} as const;

export const ATC_BUTTON_TEXTS = {
	atc: 'Add To Cart',
	noStoreSelected: 'Set Store to Add',
	notifyMe: 'Notify Me When Available',
	nearbyStores: 'See Available Stores',
	preOrder: 'Pre-Order',
	noDeliveryLocation: 'Enter Delivery Location to Add',
	enterZip: 'Enter ZIP to Add',
	customize: 'Customize'
} as const;

export const BUTTON_ACTIONS = {
	selectOptions: 'SelectOptions'
} as const;

export const CHANGE_STORE_BUTTON_TEXTS = {
	noStoreSelected: 'Select Store',
	nearbyStores: 'See available stores'
} as const;

export const STORE_CLOSED_MESSAGE = {
	temporarilyClosed: 'Store temporarily closed'
} as const;

export const LOW_STOCK_MESSAGE = (stock) => `Only ${stock} left!` as const;
